
  export default {
    data: () => ({
      progress: 0
    }),
  }
